import { X } from 'kzv-icons';
import PropTypes from 'prop-types';
import React from 'react';
import { formatByteSize } from 'utils/formatting';

function FilesList({ files, onFileRemove, thumbnails, enableDescriptions = false, onDescriptionChange }) {
    return (
        <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 justify-center overflow-auto mt-4">
            {files.map((file, i) => (
                <div className="border border-gray-100 shadow-sm rounded-2xl overflow-hidden" key={i}>
                    <div className="p-2 text-left flex space-x-6">
                        <div className="w-full flex-grow-0 overflow-hidden">
                            <div className="font-medium text-xs overflow-ellipsis whitespace-nowrap overflow-hidden">
                                {file.name}
                            </div>
                            <div className="text-secondary text-xs text-left">{formatByteSize(file.size)}</div>
                        </div>
                        <div className="flex-shrink-0 w-4">
                            <button
                                className="focus:outline-none focus:ring-0 filter drop-shadow-xl hover:text-brand-dark"
                                onClick={() => onFileRemove(file, i)}
                            >
                                <X strokeWidth={3} />
                            </button>
                        </div>
                    </div>
                    <div className="image w-full h-32 relative">
                        <img src={thumbnails[i]} alt="" className="object-cover w-full h-full" />
                    </div>
                    {enableDescriptions && onDescriptionChange && (
                        <div className="p-0">
                            {/*<TextareaField*/}
                            {/*    placeholder="Opiši kje je fotografija nastala, kaj se vidi ipd..."*/}
                            {/*    className="h-16 border-gray-200"*/}
                            {/*    value={file?.description || ''}*/}
                            {/*    onChange={(e) => onDescriptionChange(e.currentTarget.value, i)}*/}
                            {/*/>*/}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
}

FilesList.propTypes = {
    files: PropTypes.array,
    thumbnails: PropTypes.array,
    onFileRemove: PropTypes.func
};

export default FilesList;
